module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/runtime.lex.v2-2020-08-07.paginators.json
// module id = 595
// module chunks = 0